export default __webpack_public_path__ + "static/media/category-3.191191d2.webp";